<template>
    <div class="layout__height-1240px layout__overflow-hidden">
        <!--<iframe src="http://localhost:8080/fulfilment" width="100%" height="100%;" class="layout__height-3040px">-->
        <iframe :src="iframe_src" width="100%" height="100%;" class="layout__height-1240px" scrolling="no">

        </iframe>
    </div>
</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';
    import Router from '../../../router';
    import Stepguide from "../../../components/tools/quote/StepGuide";

    export default {
        name: "generateaquote",
        props: {},
        components: {
            Stepguide
        },
        mixins: [axios, dataFormatter, backing],
        computed: {
            iframe_src: {
                get: function() {
                    return `${process.env.VUE_APP_INSTANT_MARKETING_IFRAME}/profile?auth_token=${window.sessionStorage.getItem('_token')}&showProfile=true&version=${process.env.VUE_APP_DIRECTMAILR_VERSIONNUMBER}`
                }
            }
        },
        data() {
            return {
            }
        },
        beforeUpdate() {
        },
        created() {
        },
        methods: {
        },
    };
</script>